import { fetchPutIwocapaySellerPaymentCapturedCancel } from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

import { useStateKey } from '../../../hooks/useStateKey.hook';

export function useCancelCapturedPaylink({ payLinkId }: { payLinkId: string }) {
  const { stateKey } = useStateKey();

  const {
    mutateAsync: mutateCancelPayLink,
    isLoading: isCancellingPayLink,
    isError: errorCancellingPayLink,
    isSuccess: successCancellingPayLink,
  } = useMutation({
    mutationFn: () => {
      if (!stateKey) {
        throw new Error('No stateKey was provided.');
      }
      return fetchPutIwocapaySellerPaymentCapturedCancel({
        stateKey,
        payLinkId: payLinkId,
      });
    },
  });

  const cancelPayLink = async () => {
    try {
      await mutateCancelPayLink();
    } catch (_) {
      // No error handling needed as done via
      // isError in the useMutation
    }
  };

  return {
    cancelPayLink,
    isCancellingPayLink,
    errorCancellingPayLink,
    successCancellingPayLink,
  };
}
